module.exports = __webpack_public_path__ + "img/tag-video-nav-6dd7b2ef.93cded1a.png";